import React from 'react';
import { Flex, Form, Input, Upload, Radio, Cascader, InputNumber, Divider, Button, Checkbox, DatePicker, message } from 'antd';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import Geo from '../../components/geo';

const iconStyle = {
    fontSize: 28,
}

export default () => {
    const {accId, isSuper, versionId} = window.__baseInfo;
    const imageUrlPrefix = '//img.yxdj.tech/';
    const [loading, setLoading] = React.useState(false);
    const [imageUrl, setImageUrl] = React.useState();
    const [logoImage, setLogoImage] = React.useState([]);
    const [defaultPccValue, setDefaultPccValue] = React.useState([]);
    const [defaultShopPcc, setDefaultShopPcc] = React.useState([]);
    const [form] = Form.useForm(); 
    const params = new URLSearchParams(window.location.search);
    const shopId = params.get('shopId');

    React.useEffect(() => {
        if (shopId) {
            initForm();
        }
    }, []);

    const uploadButton = (
        logoImage.length < 1 && <button style={{ border: 0, background: 'none' }} type="button">
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>上传图片</div>
        </button>
    );

    const beforeUpload = async (file) => {
        // console.log('beforeUpload', file);
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
        if (!isJpgOrPng) {
            message.error('请上传JPG/PNG图片!');
        }
        const isLt = file.size / 1024 / 1024 < 2;
        if (!isLt) {
            message.error('图片必须小于 2MB!');
        }
        // console.log('upload', file);

        return isJpgOrPng && isLt;
    };

    const handleChange = (fieldName, {file, fileList}) => {
        // console.log(file.status, fieldName, file, fileList);

        if(file.status === undefined) return false;

        if(file.status === 'done') {
            let imgUrl = file.response.data.url.replace('http://weijia-hz-pub.oss-cn-hangzhou.aliyuncs.com', 'https://img.yxdj.tech');
            fileList = fileList.map((item) => {

                if(file.uid === item.uid) {
                    return { uid: item.uid, type: item.type, thumbUrl: imgUrl }
                } else {
                    return item
                }
            });
        }

        // if(file.status === 'done') console.log('done', fileList);

        if(fieldName === 'logoImage') {
            setLogoImage([...fileList]);
        }

        if (file.status === 'done') {
            setLoading(false);
        }else{
            if(loading === false) setLoading(true);
        }
    };

    const initForm = () => {
        if(shopId) {
            getShopDetail().then(res => {
                if(res.logoUrl) {
                    setLogoImage([{
                        name: 'logo',
                        status: 'done',
                        url: `${imageUrlPrefix}${res.logoUrl}`,
                    }]);
                }
                // 省市区处理

                if(res.shop_biz_address) {
                    const pcc = [];
                    const {province, provinceCode, city, cityCode, county, countyCode} = res.shop_biz_address;

                    if(provinceCode && province) { pcc.push({ name: province, adcode: provinceCode, }) }
                    else { pcc.push({})}

                    if(cityCode && city) { pcc.push({ name: city, adcode: cityCode, }) }
                    else { pcc.push({})}

                    if(countyCode && county) { pcc.push({ name: county, adcode: countyCode, }) }
                    else { pcc.push({})}

                    // console.log('pcc', pcc);
                    setDefaultPccValue(pcc);
                }

                if(res.shop_local_address) {
                    const pcc = [];
                    const {province, provinceCode, city, cityCode, county, countyCode, address} = res.shop_local_address;

                    if(provinceCode && province) { pcc.push({ name: province, adcode: provinceCode, }) }
                    else { pcc.push({})}

                    if(cityCode && city) { pcc.push({ name: city, adcode: cityCode, }) }
                    else { pcc.push({})}

                    if(countyCode && county) { pcc.push({ name: county, adcode: countyCode, }) }
                    else { pcc.push({})}

                    if(address) form.setFieldsValue({ address })

                    setDefaultShopPcc(pcc);
                }

                form.setFieldsValue({
                    ...res
                })
            });
        }
    };

    const getShopDetail = async () => {
        let response = await fetch(`/api/shop/detail?accId=${accId}&shopId=${shopId}`);
        let result = await response.json();

        if(result && result.success) {
            return(result.data);
        }
        return [];
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const values = form.getFieldsValue();

        if(values.bizScopeIds) {
            values.bizScopeIds = values.bizScopeIds.map(item => ({name: item.name, adcode: item.adcode }));
        }

        if(values.shopGeo) {
            values.shopGeo = values.shopGeo.map(item => ({name: item.name, adcode: item.adcode }));
        }

        // LOGO
        if(logoImage && logoImage.length) {
            values.logoUrl = logoImage[0]?.thumbUrl?.replace(/.*?\/\/.*?\//, '');
        }

        // 过滤掉空值
        Object.keys(values).forEach(key => {
            if(values[key] === undefined) {
                delete values[key];
            }
        });

        console.log('values', values);

        const url = shopId ? `/api/shop/edit?accId=${accId}&shopId=${shopId}` : `/api/shop/create?accId=${accId}`;

        form.validateFields().then(async () => {
            let response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(values),
            }); 

            let result = await response.json();

            if (result && result.success) {
                message.success("提交成功！");
                setTimeout(() => {
                    window.location.href = "/shop";
                }, 500);
            } else {
                message.error(result.data);
            }
        });
    };

    return (
        <div className='main-form'>
            <Form form={form}>
                <h2>{shopId ? '编辑店铺' : '创建店铺'}</h2>
                <Form.Item
                    label="店铺类型"
                    name="shopType"
                    rules={[{ required: true, message: '请选择店铺类型' }]}
                >
                    <Radio.Group options={[
                        {label: '直营店', value: 2}, 
                        {label: '加盟店', value: 3}, 
                        {label: '虚拟店', value: 4},
                        {label: '其他', value: 8},
                    ]} defaultValue="Pear" optionType="button" />
                </Form.Item>
                <Form.Item
                    label="店铺名称"
                    name="title"
                    rules={[{ required: true, message: '请输入店铺名称' }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label="店铺LOGO"
                    name="logoUrl"
                    rules={[{ required: true, message: '请输入店铺名称' }]}
                >
                    <Upload
                        fileList={logoImage}
                        listType="picture-card"
                        className="avatar-uploader"
                        maxCount={1}
                        action="/api/upload/image"
                        beforeUpload={beforeUpload}
                        onChange={(file) => handleChange('logoImage', file)}
                    >
                        {imageUrl ? <img src={imageUrl} alt="avatar" style={{ width: '100%' }} /> : uploadButton}
                    </Upload>
                </Form.Item>

                {/* <Form.Item
                    label="店铺简介"
                    name="description"
                >
                    <Input.TextArea />
                </Form.Item> */}

                <Form.Item
                    label="服务范围"
                    name="bizScopeIds"
                >
                    {/* <Cascader placeholder='全国' options={[{label: '杭州', children: [{label: '西湖区'}, {label: '余杭区'}]}]} changeOnSelect /> */}
                    <Geo defaultValue={defaultPccValue} />
                </Form.Item>    

                <Form.Item
                    label="店铺地址"
                    name="shopGeo"
                    rules={[{ required: true, message: '请输入店铺地址' }]}
                >
                    {/* <Cascader placeholder='全国' options={[{label: '杭州', children: [{label: '西湖区'}, {label: '余杭区'}]}]} changeOnSelect /> */}
                    <Geo defaultValue={defaultShopPcc} />
                </Form.Item>    

                <Form.Item
                    label="详细地址"
                    name="address"
                >
                    <Input placeholder='详细地址' />
                </Form.Item>

                <Form.Item
                    label="每周营业天数"
                    name="bizDays"
                >
                    <Checkbox.Group options={[{label: '一', value: 1}, {label: '二', value: 2}, {label: '三', value: 3}, {label: '四', value: 4}, {label: '五', value: 5}, {label: '六', value: 6}, {label: '日', value: 7}]} />
                </Form.Item>

                <Form.Item
                    label="客服电话"
                    name="contactPhoneNo"
                    rules={[{ required: true, message: '请输入客户联系电话' }]}
                >
                    <Input />
                </Form.Item>    

                {/* <Flex justify='start'>
                    <Form.Item
                        label="营业时间"
                        name="bizStartTime"
                    >
                        <DatePicker.TimePicker defaultValue={dayjs('08:00', 'HH:mm')} format={'HH:mm'} placeholder="开始时间" />
                    </Form.Item>
                    <Form.Item
                        label={<div></div>}
                        name="bizEndTime"
                    >
                        <DatePicker.TimePicker defaultValue={dayjs('18:00', 'HH:mm')} format={'HH:mm'}  placeholder="结束时间" />
                    </Form.Item>
                </Flex> */}

                {/* <Form.Item
                    label="店铺收款方式"
                    name="receiptType"
                >
                    <Radio.Group defaultValue={receiptType} options={[{label: '总公司统一收款', value: 1}, { label: '店铺独立收款', value: 2}]} />
                </Form.Item>  */}
 
                {isSuper && <Form.Item
                    hidden={window.__baseInfo.isSub === true}
                    label="总公司分成比例"
                    name="commissionPercent"
                >
                    <InputNumber addonAfter='%' precision={1} />
                </Form.Item> }

                {
                    versionId === 1 && (
                        <div>
                            <Form.Item
                                label="收款银行名称"
                                name="bankName"
                            >
                                <Input />
                            </Form.Item>
                            <Form.Item
                                label="收款账户名"
                                name="bankTitle"
                            >
                                <Input />
                            </Form.Item>
                            <Form.Item
                                label="收款账号"
                                name="bankNo"
                            >
                                <Input />
                            </Form.Item>
                        </div>
                    )
                }
                <Form.Item
                    label="结算模式"
                    name="settlementModel"
                    initialValue={'HEAD'}
                    help='总部结算：订单结算给总部；店铺结算：订单直接结算给店铺；仅连锁版支持店铺结算'
                >
                    <Radio.Group disabled={versionId !== 3} options={[
                        { value: 'HEAD', label: '总部结算' },
                        { value: 'SHOP', label: '店铺结算' },
                    ]} />
                </Form.Item>
                <Form.Item
                    label="公司名称"
                    name="companyName"
                >
                    <Input placeholder='请输入公司名称' style={{width: '200px'}} />
                </Form.Item> 

                <Form.Item
                    label="微信商户号"
                    name="mchid"
                >
                    <Input placeholder='请输入微信商户号' style={{width: '200px'}} />
                </Form.Item> 
            </Form>
            <Divider />
            <Flex gap={10} align='center' justify='center'>
                <Button href='/shop'>取消</Button>
                <Button type="primary" onClick={handleSubmit}>提交</Button>
            </Flex>
        </div>
    )
}